/**
 * Componente de visualização para estado de código de convite inválido.
 * Este componente é renderizado quando um código de convite para vinculação de usuário 
 * é inválido, expirou, ou já foi utilizado.
 */
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';
import Afinandinho_surprised from "../../../../../assets/images/Afinandinho_surprised.svg";

/**
 * Componente InvalidCodeView - Exibe mensagem de erro quando o código de convite é inválido.
 * 
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {string} props.errorMessage - Mensagem de erro específica para exibir ao usuário (opcional)
 * @param {string} props.inviterName - Nome do profissional que enviou o convite
 * @param {Function} props.redirectToDashboard - Função para redirecionar o usuário ao painel principal
 * @returns {JSX.Element} Tela de código inválido com mensagem explicativa e botão para voltar
 */
const InvalidCodeView = ({ errorMessage, inviterName, redirectToDashboard }) => {
  return (
    // Container principal com estilo específico para este estado
    <StateView className={classes.invalidCodeContainer}>
      {/* Título principal da tela */}
      <H1 className={classes.invalidCodeTitle}>Ops! O convite não é mais válido</H1>

      {/* Mensagem explicativa para o usuário */}
      <LinkMessage className={classes.invalidCodeMessage}>
        {/* Explicação sobre possíveis causas do erro */}
        <p>Ele pode ter expirado ou sido utilizado por outra pessoa. </p>
        
        {/* Orientações para o usuário resolver o problema */}
        <p>
          Tente acessar novamente ou entre em contato com {inviterName} para receber um novo link de vinculação.
        </p>
        
        {/* Exibe mensagem de erro específica se disponível */}
        {/* {errorMessage && <p><strong>{errorMessage}</strong></p>} */}
      </LinkMessage>

      {/* Ícone ilustrativo do estado - avatar Afinandinho surpreso */}
      <StateIcon 
        imageSrc={Afinandinho_surprised}
        altText="Afinandinho Surprised Icon"
        iconContainerClass={classes.invalidCodeIconContainer}
        iconClass={classes.invalidCodeIcon}
      />

      {/* Botão para retornar ao painel principal */}
      <RoundedButton
        className={classes.returnButton}
        text="VOLTAR AO PAINEL"
        onClick={redirectToDashboard}
      />
    </StateView>
  );
};

export default InvalidCodeView;